import React from 'react';
import ContactTile from '@gik/contact/components/ContactTile/ContactTile';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/contact/i18n/en';

export default function BusinessInquiries() {
  const bem = useBemCN('business-inquiries');
  const { t } = useTranslation();

  return (
    <ContactTile
      {...bem()}
      title={t(translationKeys.BusinessInquiriesTitle)}
      buttonText={t(translationKeys.BusinessInquiriesButtonText)}
      buttonLink="https://create.giveinkind.com/local-business-submissions/"
    >
      {t(translationKeys.BusinessInquiriesContent)}
    </ContactTile>
  );
}
